<template>
  <v-container>
    <h2>{{ $t("tagManagement") }} | {{ merchantName }}</h2>
    <!-- 全頁 Loading -->
    <v-overlay :value="overlayLoading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>

    <DualListSelector
      :modeOptions="modeOptions"
      :defaultMode="defaultMode"
      :modeLabel="modeLabel"
      :error="error"
      :searchByOptions="searchByOptions"
      :defaultSearchBy="defaultSearchBy"
      :tableHeaders="headers"
      :appliedList="appliedList"
      :unappliedList="unappliedList"
      :selectedApplied.sync="selectedApplied"
      :selectedUnapplied.sync="selectedUnapplied"
      :appliedPagination="appliedPagination"
      :unappliedPagination="unappliedPagination"
      :loadingApplied="loadingApplied"
      :loadingUnapplied="loadingUnapplied"
      :appliedSearch="appliedSearch"
      :unappliedSearch="unappliedSearch"
      :itemsPerPage="itemsPerPage"
      @update:mode="mode = $event"
      @update:itemsPerPage="
        itemsPerPage = $event;
        appliedPagination.page = 1;
        undefinedappliedPagination.page = 1;
      "
      @update:appliedSearch="onAppliedSearchUpdate"
      @update:unappliedSearch="onUnappliedSearchUpdate"
      @fetch-applied-list="fetchAppliedList"
      @fetch-unapplied-list="fetchUnappliedList"
      @apply-one="applyOne"
      @unapply-one="unapplyOne"
      @apply-selected="applySelected"
      @unapply-selected="unapplySelected"
      @mode-changed="onModeChange"
      @items-per-page-changed="onModeChange"
    />
  </v-container>
</template>

<script>
import DualListSelector from "@/components/DualListSelector.vue";
import axios from "axios";

export default {
  components: { DualListSelector },
  props: {
    merchantId: String,
    merchantName: String,
    merchant: Object
  },
  data() {
    return {
      mode: "",
      defaultMode: "tags", // 要是modeOptions裡有的
      defaultSearchBy: "name",
      error: "",
      itemsPerPage: 10,
      appliedSearch: "",
      appliedSearchBy: "",
      unappliedSearch: "",
      unappliedSearchBy: "",
      appliedList: [],
      unappliedList: [],
      selectedApplied: [],
      selectedUnapplied: [],
      appliedPagination: { page: 1, total: 0 },
      unappliedPagination: { page: 1, total: 0 },
      loadingApplied: false,
      loadingUnapplied: false
      // overlayLoading: false,
    };
  },
  computed: {
    overlayLoading() {
      return this.loadingApplied || this.loadingUnapplied;
    },
    modeOptions() {
      return [
        { value: "tags", text: this.$t("tag"), key: "id" }
        // { value: 'group', text: '群組' }
      ];
    },
    modeLabel() {
      return this.modeOptions.find(opt => opt.value === this.mode)?.text || "";
    },
    headers() {
      return [
        {
          text: `${this.modeLabel}${this.$t("tags.name")}`,
          value: "name",
          sortable: false
        },
        { text: this.$t("tags.actions"), value: "actions", sortable: false }
      ];
    },
    searchByOptions() {
      return [{ text: this.$t("tags.name"), value: "name" }];
    },
    appliedSearchString() {
      if (this.appliedSearch)
        return `search=${this.appliedSearchBy}:${encodeURIComponent(
          this.appliedSearch
        )}`;
      else "";
    },
    unappliedSearchString() {
      if (this.unappliedSearch)
        return `search=${this.unappliedSearchBy}:${encodeURIComponent(
          this.unappliedSearch
        )}`;
      else "";
    }
  },
  methods: {
    normalizeData(items) {
      // 尋找對應的 key (merchantId 或 groupId)
      const modeOption = this.modeOptions.find(
        option => option.value === this.mode
      );
      // if (!modeOption) {
      //   console.warn(`未找到模式 "${selectedMode}" 對應的設定。`);
      //   return [];
      // }

      const idKey = modeOption?.key || "id"; // 獲取對應的 id 鍵，例如 'merchantId' 或 'groupId'

      return items.map(item => ({
        name: item.name,
        id: item[idKey]
      }));
    },
    onModeChange() {
      this.appliedPagination.page = 1;
      this.unappliedPagination.page = 1;
      this.appliedSearch = "";
      this.appliedSearchBy = this.defaultSearchBy;
      this.unappliedSearchBy = this.defaultSearchBy;
      this.unappliedSearch = "";
      this.fetchAppliedList(1);
      this.fetchUnappliedList(1);
    },
    async fetchAppliedList(page = 1) {
      this.loadingApplied = true;
      try {
        const res = await this.fetchData({
          mode: this.mode,
          // search: this.appliedSearchBy ? `${this.appliedSearchBy}:${this.appliedSearch}` : this.appliedSearch,
          page,
          limit: this.itemsPerPage,
          applied: true
        });
        this.appliedList = this.normalizeData(res.items);
        this.appliedPagination.total = res.total;
        this.appliedPagination.page = page;
        this.loadingApplied = false;
      } catch (e) {
        console.log('failed to fetch applied list');
        this.loadingApplied = false;
        this.$notify({
          text: `Failed to fetch applied list`,
          type: "error"
        });
      }
    },
    async fetchUnappliedList(page = 1) {
      this.loadingUnapplied = true;
      try {
        const res = await this.fetchData({
          mode: this.mode,
          // search: this.unappliedSearchBy ? `${this.unappliedSearchBy}:${this.unappliedSearch}` : this.unappliedSearch,
          page,
          limit: this.itemsPerPage,
          applied: false
        });
        this.unappliedList = this.normalizeData(res.items);
        this.unappliedPagination.total = res.total;
        this.unappliedPagination.page = page;
        this.loadingUnapplied = false;
      } catch (e) {
        console.log('failed to fetch unapplied list');
        this.loadingUnapplied = false;
        this.$notify({
          text: `Failed to fetch unapplied list`,
          type: "error"
        });
      }
    },
    async applyData(tags) {
      axios
        .post(
          `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/merchants/${this.merchantId}/add-tags`,
          { tags }
        )
        .then(response => {
          this.$notify({
            text: `Tag applied:  ${tags.length} ${
              tags.length > 1 ? "tags" : "tag"
            }`,
            type: "success"
          });
          this.appliedPagination.page = 1;
          this.unappliedPagination.page = 1;
          this.fetchAppliedList(1);
          this.fetchUnappliedList(1);
        })
        .catch(err => {
          console.error(`Failed to apply tag`, err);
          this.$notify({
            text: `Tag applied failed: ${err.message}`,
            type: "error"
          });
        });
    },
    async unapplyData(tags) {
      console.log("unapplyData", tags);
      axios
        .delete(
          `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/merchants/${this.merchantId}/delete-tags`,
          { data: { tags } }
        )
        .then(response => {
          this.$notify({
            text: `Tag unapplied:  ${tags.length} ${
              tags.length > 1 ? "tags" : "tag"
            } `,
            type: "success"
          });
          this.appliedPagination.page = 1;
          this.unappliedPagination.page = 1;
          this.fetchAppliedList(1);
          this.fetchUnappliedList(1);
        })
        .catch(err => {
          console.error(`Failed to apply tag`, err);
          this.$notify({
            text: `Tag applied failed (${item.name}): ${err.message}`,
            type: "error"
          });
        });
    },
    applyOne(item) {
      console.log("apply-one", item);
      let data = [item.id];
      this.applyData(data);
    },
    unapplyOne(item) {
      console.log("unapply-one", item);
      let data = [item.id];
      this.unapplyData(data);
    },
    applySelected() {
      console.log("applySelected", this.selectedUnapplied);
      const data = this.selectedUnapplied.map(item => item.id);
      this.applyData(data);
      this.selectedUnapplied = [];
    },
    unapplySelected() {
      console.log("unapplySelected", this.selectedApplied);
      const data = this.selectedApplied.map(item => item.id);
      this.unapplyData(data);
      this.selectedApplied = [];
    },
    onAppliedSearchUpdate(event) {
      this.appliedSearchBy = event.searchBy;
      this.appliedSearch = event.keyword;
    },
    onUnappliedSearchUpdate(event) {
      this.unappliedSearchBy = event.searchBy;
      this.unappliedSearch = event.keyword;
    },
    async fetchData({ mode, page = 1, limit = 10, applied = true }) {
      const querystring = applied
        ? this.appliedSearchString
        : this.unappliedSearchString;
      const startIndex = (page - 1) * limit;
      const url =
        `${process.env.VUE_APP_QRPAY_ADMIN_HOST}/api/merchants/${this.merchantId}/tags` +
        `?useTag=${applied}&limit=${limit}&startIndex=${startIndex}` +
        (querystring ? `&${querystring}` : "");

      const fetchRes = await axios.get(url);
      return {
        items: fetchRes.data.data,
        total: fetchRes.data.total
      };
    }

    // mockFetchData({ mode, search = "", page = 1, limit = 10, applied = true }) {

    //   const type = mode === "merchant" ? "merchantId" : "groupId";
    //   const totalItems = Array.from({ length: 50 }).map((_, i) => ({
    //     name: `${applied ? "已套用" : "未套用"} ${
    //       mode === "merchant" ? "店家" : "群組"
    //     } ${i + 1}`,
    //     [type]: `${mode}-${i + 1}`
    //   }));

    //   const filtered = totalItems.filter(item => item.name.includes(search));
    //   const paged = filtered.slice((page - 1) * limit, page * limit);

    //   return new Promise(resolve => {
    //     setTimeout(() => {
    //       resolve({ items: paged, total: filtered.length });
    //     }, 300);
    //   });
    // },
  },
  mounted() {
    // this.fetchAppliedList();
    // this.fetchUnappliedList();
  },
  watch: {
    merchantId: {
      immediate: true,
      handler(mId) {
        this.fetchAppliedList(1);
        this.fetchUnappliedList(1);
      }
    }
  }
};
</script>
